<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="ProSoJishiViewInfo"
                :filter_thousandth="['planSum','finishSum']"
                :header="tableHeader"
                :option="tableOption"
                ref="singleTable"
                :checkflg="false"
        ></wTable>
        <!--<el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
        >
<el-table-column show-overflow-tooltip prop="planDate" :label="$t('getapi[4053]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="planSum" :label="$t('getapi[5029]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="finishSum" :label="$t('getapi[5030]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="rate" :label="$t('getapi[5031]')"></el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ProSoJishiViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[4039]')" queryData="ProSoJishiViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'2_sofinish',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('sofinish'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                selectData: [],
                btn:{
                    endIssue: false
                },
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[4039]"),this.$t("getapi[20]"));
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('ProSoJishiViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (that.total > 0) {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                } else {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                }
                
                
                that.btnauthority();
            },
            btnauthority(){
                let that = this
                that.btn.endIssue = false
                if(that.selectData.length > 0){
                    that.btn.endIssue = true
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('sofinish',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ProSoJishiViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.pageIndex = 1;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let token = JSON.parse(that.userData).token;
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pro/MDIP/SOTCRList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Pro/MDIP/SOTCRExportToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ProSoJishiViewInfo",
                    fromname: that.$t('getapi[4039]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.btnauthority()
            },
            endIssue(){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        so_code: that.selectData[i].so_code,
                        part_id: that.selectData[i].part_id
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SO/SOMaterilEndIssue', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
